import { ResultData } from "../enums/index.js";

const PITCH_PROPERTY = 'pitch';
const HIT_PROPERTY = 'hit';

class ResultPair {
    constructor(pitch, hit) {
        this.pitch = pitch;
        this.hit = hit;
    }

    hasPitch() {
        return this.pitch !== null;
    }

    hasHit() {
        return this.hit !== null;
    }

    getPitch() {
        return this.pitch;
    }

    getHit() {
        return this.hit;
    }

    contains(resultId) {
        return (
            (this.hasPitch() && this.pitch[ResultData.Id.key] === resultId)
            || (this.hasHit() && this.hit[ResultData.Id.key] === resultId)
        );
    }

    static getPitchProperty() {
        return PITCH_PROPERTY;
    }

    static getHitProperty() {
        return HIT_PROPERTY;
    }
}

export default ResultPair;